import React from 'react';
import { NavLink } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaFutbol, FaLayerGroup, FaMoneyBillWave, FaBook, FaChartLine } from 'react-icons/fa';
import useReducedMotion from '../hooks/useReducedMotion';

const navTap = { scale: 0.9 };
const navItems = [
  { to: '/', end: true, icon: FaFutbol, label: 'Predictions', shortLabel: 'Picks' },
  { to: '/accumulators/', icon: FaLayerGroup, label: 'Accumulators', shortLabel: 'Accas' },
  { to: '/bookie-bonuses/', icon: FaMoneyBillWave, label: 'Bonuses' },
  { to: '/results', icon: FaChartLine, label: 'Results' },
  { to: '/betting-guides/', icon: FaBook, label: 'Guides' },
];

const BottomNav = () => {
  const reduceMotion = useReducedMotion();

  return (
    <motion.nav
      className="bottom-nav pb-safe touch-manipulation lg:hidden"
      aria-label="Main navigation"
      initial={reduceMotion ? false : { y: 100 }}
      animate={{ y: 0 }}
      transition={{ duration: reduceMotion ? 0 : 0.3 }}
    >
      <div className="w-full md:max-w-5xl md:mx-auto md:px-6">
        <div className="grid grid-cols-5 h-16">
          {navItems.map(({ to, end, icon: Icon, label, shortLabel }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                `bottom-nav-item ${isActive ? 'text-primary' : 'text-gray-500 dark:text-gray-400'}`
              }
            >
              {({ isActive }) => (
                <motion.div
                  whileTap={reduceMotion ? undefined : navTap}
                  className="flex flex-col items-center w-full min-w-0 max-w-full"
                >
                  <span className="bottom-nav-pill">
                    {isActive && (
                      <motion.span
                        layoutId={reduceMotion ? undefined : 'bottomNavPill'}
                        className="bottom-nav-pill-bg"
                        aria-hidden="true"
                      />
                    )}
                    <Icon className="bottom-nav-icon" aria-hidden="true" />
                  </span>
                  <span className="truncate max-w-full leading-tight px-0.5">
                    <span className="sm:hidden">{shortLabel || label}</span>
                    <span className="hidden sm:inline">{label}</span>
                  </span>
                </motion.div>
              )}
            </NavLink>
          ))}
        </div>
      </div>
    </motion.nav>
  );
};

export default BottomNav;
